import { formatSecondsToDuration } from "@tvg/formatter/dates";

const formatWinningTime = (winningTime: number | string) =>
  typeof winningTime === "number"
    ? formatSecondsToDuration(winningTime)
    : winningTime;

export default formatWinningTime;
